import { usePopulationSetting } from 'flow/settings/population'
import useFetch from 'hooks/fetch'

const useUserData = () => {
  const [selectedPopulation] = usePopulationSetting()
  return useFetch(`/userData/${selectedPopulation.value}.json`)
}

const useAllUserData = () => {
  return useFetch('/userData/all.json')
}

export default useUserData

export {
  useAllUserData
}
